export const SET_CAPTURE_TYPE = 'SET_CAPTURE_TYPE';
export const SET_TAB = 'SET_TAB';
export const SET_DEVICE_LIST = 'SET_DEVICE_LIST';
export const SET_VIDEO_DEVICE = 'SET_VIDEO_DEVICE';
export const SET_AUDIO_DEVICE = 'SET_AUDIO_DEVICE';
export const SET_SHOW_COUNTDOWN = 'SET_SHOW_COUNTDOWN';
export const SET_FLIP_CAMERA = 'SET_FLIP_CAMERA';
export const SET_MEDIA_PERMISSION = 'SET_MEDIA_PERMISSION';
export const RECORDING_CODECS_BY_OS = 'RECORDING_CODECS_BY_OS';
